module.exports = __webpack_public_path__ + "img/clothing97.c67de516.jpg";